import { useMemo } from 'react';
import { useCosmosEditorial } from 'providers/contexts/CosmosEditorialContext';

export const usePresentationTypes = () => {
  const { editorialConfig } = useCosmosEditorial();

  const {
    articlePresentationTypes,
    imagePresentationTypes,
    collectionPresentationTypes,
  } = useMemo(() => {
    const getPresentationTypes = (typeName: string) => {
      const assetType = editorialConfig?.asset_types?.find((type) => type.name === typeName);
      return (
        assetType?.presentations
          ?.filter((p): p is { label: string; value: string } => typeof p.label === 'string' && typeof p.value === 'string')
          .map(({ label, value }) => ({ label, value })) ?? []
      );
    };

    return {
      articlePresentationTypes: getPresentationTypes('article'),
      imagePresentationTypes: getPresentationTypes('image'),
      collectionPresentationTypes: getPresentationTypes('collection'),
    };
  }, [editorialConfig]);

  return { articlePresentationTypes, imagePresentationTypes, collectionPresentationTypes };
};